var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { useNote, useNoteTemplate } from 'shared/hooks';
import { useNoteForPathContext } from './noteForPathContext';
var copyForwardContext = createContext({
    copyForwardDate: null,
    copyForwardTemplate: null,
    isVisible: false,
});
export var CopyForwardProvider = function (_a) {
    var _b, _c;
    var children = _a.children;
    var noteId = useNoteForPathContext().noteId;
    var getNote = useNote(noteId);
    var noteTemplate = useNoteTemplate();
    var copyForwardDate = useMemo(function () {
        var _a;
        if (noteTemplate.data && ((_a = noteTemplate.data.sessionInfo) === null || _a === void 0 ? void 0 : _a.start)) {
            return noteTemplate.data.sessionInfo.start;
        }
        return null;
    }, [noteTemplate]);
    var isVisible = !((_b = getNote.data) === null || _b === void 0 ? void 0 : _b.signedAt);
    var copyForwardTemplate = (_c = noteTemplate === null || noteTemplate === void 0 ? void 0 : noteTemplate.data) !== null && _c !== void 0 ? _c : null;
    return (_jsx(copyForwardContext.Provider, __assign({ value: { copyForwardDate: copyForwardDate, isVisible: isVisible, copyForwardTemplate: copyForwardTemplate } }, { children: children })));
};
export var useCopyForwardContext = function () {
    var ctx = useContext(copyForwardContext);
    if (ctx === undefined) {
        throw new Error('useCopyForwardContext must be used within a CopyForwardProvider');
    }
    return ctx;
};
